module.exports = {
	colors: {
		main: '#2e7c55',
		sec: '#ce8b5e',
		alt: '#2e7c55',
	},

	showFunds: true,
	showBuses: false,
	useBusAssistantGPS: false,
	showHomeworks: true,
	showSchoolDay: true,
	showLanguages: false,
	useCourses: false,
	useUploadChatImage: false,

	about: {
		mobiles: ['+963947951883'],
		phones: [],
		address: 'حلب - حلب الجديدة جنوبي - حي البحوث العلمية',
		data: [36.1987208607509, 37.08985852209043],
		branches: [],
		email: null,
		facebook: 'https://www.facebook.com/share/1XwxP4ULKW/',
		telegram: null,
		privacy: null,
		details: [
			{
				title: 'معهد القرآن الكريم وعلومه في جامع الإمام علي زين العابدين بحلب الجديدة',
				content: [
					'نال المراكز الأولى على مستوى الجمهورية العربية السورية بعد تأهيل الطلاب وتدريبهم.',
					'',
					'يقوم المعهد على برنامج قرآني تربوي متكامل يجمع بين حفظ كتاب الله، وتصحيح التلاوة، وغرس القيم الإيمانية والشخصية الواعية، بخبرات تدريسية تزيد على خمسة وعشرين عامًا.',
					'',
					'من ميزات المعهد:',
					'١- تحفيظ القرآن الكريم حتى أخذ الإجازة بالسند المتصل إلى رسول الله ﷺ.',
					'٢- دروس رديفة في الحديث والفقه وما لا بد للمسلم منه.',
					'٣- نشاطات ثقافية، ورحلات، وهدايا محفزة.',
					'٤- دورات علمية وتنموية مثل استخدام الحاسوب وبرامجه.',
				],
			},
		],
	},

	pwa: {
		name: 'Zein Abedeen',
		shortName: 'Zein Abedeen',
		description: 'Zein Abedeen app - portal version for Zein Abedeen mobile app.',
	},
};
